const cards = [
  {
    title: '咒术回战 最终章上线',
    desc: '芥见下下倾力打造的超人气暗黑战斗漫画迎来完结，全卷现已完整上线哔咔动漫。五条悟与宿傩的终极对决终于画上句号。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20battle%20manga%20illustration%20with%20sorcerer%20characters%20casting%20cursed%20energy%20attacks%2C%20dynamic%20composition%20with%20swirling%20dark%20energy%20and%20glowing%20coral%20red%20effects%2C%20Japanese%20urban%20fantasy%20setting%20with%20modern%20buildings%2C%20high%20contrast%20dramatic%20lighting%2C%20shonen%20manga%20art%20style%20with%20detailed%20linework&width=800&height=500&seq=card-jujutsu-kaisen&orientation=landscape',
  },
  {
    title: '间谍过家家 欢乐日常',
    desc: '远藤达哉的现象级作品，伪装的间谍家庭日常充满笑料与温情。安妮亚的颜艺表情包早已火遍全网，现在全集免费下拉畅读。',
    img: 'https://readdy.ai/api/search-image?query=Heartwarming%20family%20comedy%20manga%20illustration%20with%20spy%20father%20assassin%20mother%20and%20telepath%20daughter%20having%20dinner%20together%2C%20cozy%20living%20room%20setting%20with%20warm%20golden%20lighting%2C%20playful%20expressions%20and%20gestures%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20slice%20of%20life%20art%20style&width=800&height=500&seq=card-spy-family&orientation=landscape',
  },
  {
    title: '鬼灭之刃 全系列上线',
    desc: '吾峠呼世晴的封神之作，灶门炭治郎的灭鬼之路感动了全球亿万读者。包含本篇、外传及番外全系列，一口气重温热血与感动。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20demon%20slayer%20manga%20style%20illustration%20with%20warrior%20character%20wielding%20katana%20using%20water%20breathing%20technique%2C%20flowing%20water%20dragon%20effect%20in%20vibrant%20blue%20and%20coral%2C%20traditional%20Japanese%20village%20background%20at%20night%20with%20lanterns%2C%20dynamic%20action%20pose%2C%20cinematic%20lighting%20with%20moonlight&width=800&height=500&seq=card-demon-slayer&orientation=landscape',
  },
  {
    title: '一人之下 国漫之光',
    desc: '米二创作的现象级国漫，融合道家文化与现代都市的异人世界。张楚岚与冯宝宝的冒险故事精彩纷呈，国漫爱好者必看之作。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20with%20martial%20artist%20characters%20using%20qi%20energy%20techniques%20in%20modern%20city%20setting%2C%20flowing%20ink%20and%20brushstroke%20effects%2C%20traditional%20taoist%20symbols%20floating%20in%20air%2C%20warm%20coral%20and%20gold%20color%20scheme%2C%20dynamic%20composition%20with%20energy%20waves&width=800&height=500&seq=card-under-one-person&orientation=landscape',
  },
  {
    title: '关于史莱姆 异世界经典',
    desc: '伏濑原作的异世界转生题材标杆作品，从弱小史莱姆到建立魔物联邦的传奇旅程。轻松搞笑的日常与宏大世界观完美结合。',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20isekai%20manga%20illustration%20with%20blue%20slime%20character%20and%20adventurer%20companions%20in%20medieval%20fantasy%20town%2C%20colorful%20magic%20effects%20and%20sparkles%2C%20warm%20sunny%20day%20with%20blue%20sky%2C%20playful%20and%20whimsical%20atmosphere%2C%20detailed%20fantasy%20architecture%20background%2C%20vibrant%20coral%20and%20golden%20accents&width=800&height=500&seq=card-slime-isekai&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            新番速递
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            近期上线的热门漫画精选推荐，总有一部适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((c) => (
            <div
              key={c.title}
              className="group rounded-xl overflow-hidden border border-background-200/60 bg-background-50 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={c.img}
                  alt={`哔咔动漫${c.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                    热门推荐
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base text-foreground-900 mb-2">{c.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}